module.exports = __webpack_public_path__ + "img/LTE:ERR - WLAN:OK - Popover.1013ca97.jpg";